export default {
    state: {
        name: "",
        nameU: "",
        Connectors: ([] = []),
        Shape_Transform: ([] = []),
        Connection_Points: ([] = []),
        Variants: ([] = []),
        Custom_Properties: ([] = []),
        Actions: ([] = []),
        Controls: ([] = []),
        Numbers: ([] = []),
        Geometry: [],
        Protection: ([] = []),
        Misc: ([] = []),
        Group_Properties: ([] = []),
        Events: ([] = []),
        Text_Blocks: [],
        Block_Type: {
            Connectors: 0,
            Shape_Transform: 1,
            Connection_Points: 2,
            Variants: 3,
            Custom_Properties: 4,
            Actions: 5,
            Controls: 6,
            Numbers: 7,
            Geometry: 8,
            Protection: 9,
            Misc: 10,
            Group_Properties: 11,
            Events: 12,
            Text_Blocks: 13,
        },
        ModifyType: {
            MoveTo: 0,
            LineTo: 1,
            CurveTo: 2,
            ArcTo: 3,
            EllipArc: 4,
            Ellipse: 5,
            ArcTo2: 6,
        },
    },
    getters: {
        Connectors_key: (state) => {
            return ["BeginX", "EndX", "BeginY", "EndY"];
        },
        Shape_Transform_key: (state) => {
            return ["Width", "GPinX", "FlipX", "Height", "GPinY", "FlipY", "Angle", "LocPinX", "LocPinY"];
        },
        Connection_Points_key: (state) => {
            return ["X", "Y", "Type"];
        },
        Variants_key: (state) => {
            return ["Value", "Prompt"];
        },
        Custom_Properties_key: (state) => {
            return ["Label", "Type", "Format", "Value", "Invisible", "TextID", "Unit"];
        },
        Actions_key: (state) => {
            return ["Action", "Menu", "Checked", "Disabled", "Invisible", "Timer"];
        },
        Controls_key: (state) => {
            return ["X", "Y", "DynX", "DynY", "XBehavior", "YBehavior", "CanGlue", "AutoSnap", "Disabled", "CtrlFlag"];
        },
        Numbers_key: (state) => {
            return ["X", "Y", "A", "B"];
        },
        Geometry_key: (state) => {
            return ["NoFill", "NoLine", "Closed", "NoShow"];
        },
        Protection_key: (state) => {
            return [
                "LockWidth",
                "LockBegin",
                "LockTextEdit",

                "LockHeight",
                "LockEnd",
                "LockVtxEdit",

                "LockCalcWH",
                "LockSelect",
                "LockFormat",

                "LockMoveX",
                "LockDelete",
                "LockTheme",

                "LockMoveY",
                "LockRotate",
                "LockGroupFormat",

                "LockCustProp",
                "LockGroup",
                "LockGroupFill",

                "LockShadow",
                "LockFromConnector",
                "LockSnapOutline",
            ];
        },
        Misc_key: (state) => {
            return [
                "NoObjHandles",
                "NoCtrlHandles",
                "NoAlignBox",

                "HideText",
                "HideShape",
                "ShapeType",

                "FillAlternate",
                "FillAsWhole",
                "IgnoreExtend",

                "FillWithLine",
                "NoWidthFml",
                "NoHeightFml",

                "FillClip",
                "SizeShapeNum",
                "BoxOutline",

                "Type",
                "QuickMask",
                "QuickIndex",
            ];
        },
        Group_Properties_key: (state) => {
            return ["SelectMode", "GroupShadow"];
        },
        Events_key: (state) => {
            return ["EventDrop", "EventClick"];
        },
        Text_Blocks_key: (state) => {
            return ["Width", "GPinX", "LocPinX", "Height", "GPinY", "LocPinY", "Angle", "TxtField", "TextMode"];
        },
    },
    mutations: {
        initDataSheet(state, object) {
            state.name = object.name || "";
            state.nameU = object.nameU || "";
            state.Connectors = object.Connectors || [];
            state.Shape_Transform = object.Shape_Transform || [];
            state.Connection_Points = object.Connection_Points || [];
            state.Variants = object.Variants || [];
            state.Custom_Properties = object.Custom_Properties || [];
            state.Actions = object.Actions || [];
            state.Controls = object.Controls || [];
            state.Numbers = object.Numbers || [];
            state.Geometry = object.Geometry || [];
            state.Protection = object.Protection || [];
            state.Misc = object.Misc || [];
            state.Group_Properties = object.Group_Properties || [];
            state.Events = object.Events || [];
            state.Text_Blocks = object.Text_Blocks || [];
            // console.log(object)
        },
    },
};
